/**
 * Shared Hooks Index
 *
 * Central export for all shared hooks
 */

export { useModal } from './useModal';
export { useLogoutCleanup } from './useLogoutCleanup';
export { useUnsavedChanges } from './useUnsavedChanges';
export { useAutoSave } from './useAutoSave';
export type { AutoSaveStatus } from './useAutoSave';
export { useArchiveWarningToast } from './useArchiveWarningToast';
